/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
import withModal from '../../../lib/withModal';
import EditInvoiceDialog from '../containers/EditInvoiceDialog';

const EditButton = styled(Button)`
    .ui.icon.button& > .icon {
        opacity: 1;
    }
`;

const EditInvoiceButton = ({
    open,
    onOpen,
    onClose,
    invoiceId,
    item,
    client,
    invoiceType,
    archived,
}) => (
    <EditInvoiceDialog
        trigger={
            // Wrapped in a <span> so Semantic's Portal tracks a real DOM node
            // for its outside-click handling — handing it the styled Button
            // directly resolves to a non-DOM ref under React 17 and crashes
            // with "node.contains is not a function". (Mirrors ClientSelect.)
            <span style={{ float: 'right' }}>
                <EditButton color="blue" icon="edit" onClick={onOpen} />
            </span>
        }
        open={open}
        onClose={onClose}
        invoiceId={invoiceId}
        item={item}
        client={client}
        invoiceType={invoiceType}
        archived={archived}
    />
);

export default withModal(EditInvoiceButton);
